import { Box, Text } from "@chakra-ui/react";
import { useAccent2, useAccent6, useBackground, useForeground } from "src/modeAwareColors";

/**
 * selectable pill button
 */
function Pill({ isSelected, children, onClick, ...rest }) {
  const a2 = useAccent2()
  const fg = useForeground()
  const bg = useBackground()
  const a6 = useAccent6()

  return (
    <Box
      px={3}
      py={1}
      cursor='pointer'
      onClick={onClick}
      backgroundColor={isSelected ? a2 : bg}
      color={isSelected ? fg : a6}
      borderColor={isSelected ? fg : a2}
      borderWidth={1}
      borderRadius='99px'
      transition='.3s all'
      _hover={{
        bg: useAccent2(),
        transition: '.18s all',
        borderColor: fg,
        color: fg,
      }}
      {...rest}
    >
      <Text
        fontSize='sm'
        fontWeight={400}
        letterSpacing='wide'
        whiteSpace='nowrap'
      >
        {children}
      </Text>
    </Box>
  );
}

export default Pill
